class RouteItems {
  get rules() {
    return {
      toi: "integer|validationRules|toiSignedMandatory",
      oi: "integer|validationRules",
      service_type_id: "validationRules",
      reason_for_not_signing_id: "reasonForNotSigning:route_id",
      jobs: "serviceTypePermission|abnormalityRestriction",
      provider_id: "validationRules",
      meter_number: "integer|validationRules",
      meter_installed: "integer|validationRules",
      meter_type: "validationRules",
      cp: "integer|validationRules",
      installed_cs_module: "sealValidator",
      cs: "integer|validationRules",
      pos: "integer|validationRules",
      client_number: "integer|validationRules",
      client_address: "string|validationRules",
      client_name: "string|validationRules",
      client_city: "string|validationRules",
      client_district: "string|validationRules",
      client_lat: "validationRules|coordinates",
      client_long: "validationRules|coordinates",
      notes: "validationRules",
      tdc: "integer|validationRules",
      cod_reading: "integer|validationRules",
      trafo: "integer|validationRules",
      security_screw: "validationRules",
      customer_reading: "integer|validationRules",
      handbag_number: "integer|validationRules",
      tdc_created_at: "date|validationRules",
      tdc_type: "string|validationRules",
      work_cycle: "string|validationRules",
      reading_route: "string|validationRules|readingRoute",
      location_reference: "string|validationRules",
      cep: "integer|validationRules",
      deadline_ans: "date|validationRules",
      planned_start_date: "date|validationRules",
      expected_completion_date: "date|validationRules",
      coelce_number: "integer|validationRules",
      meter_brand: "string|validationRules",
      meter_model: "string|validationRules",
      number_of_turns: "number|validationRules",
      registrar_type: "string|validationRules",
      meter_manufacturing_number: "integer|validationRules",
      operating_unit: "string|validationRules",
      location: "string|validationRules",
      area: "string|validationRules",
      local: "integer|validationRules",
      provided_document: "requiredIfCustom:toi,route_id",
      provided_phone: "requiredIfCustom:toi,route_id",
      provided_email: "requiredIfCustom:toi,route_id",
      accompanied_inspection: "requiredIfCustom:toi,route_id",
      charge_lifted: "requiredIfCustom:toi,route_id",
    }
  }

  get messages() {
    return {
      "toi.integer": "TOI's deve ser um valor númerico",
      "oi.integer": "OI deve ser um valor numérico",
      "client_number.integer": "Número do cliente deve ser numérico.",
      "cp.integer": "CP deve ser numérico.",
      "cs.integer": "CS deve ser numérico.",
      "pos.integer": "POS deve ser numérico.",
      "tdc.integer": "TDC deve ser numérico.",
      "client_address.string": "Enderesso do cliente dever conter caracteres.",
      "client_name.string": "Enderesso do cliente dever conter caracteres.",
      "client_city.string": "Enderesso do cliente dever conter caracteres.",
      "client_district.string": "Enderesso do cliente dever conter caracteres.",
      "trafo.integer": "Campo Trafo deve ser numérico.",
      "cod_reading.integer": "Código de leitura deve ser numérico.",
      "meter_number.integer": "Número do Medidor deve ser numérico.",
      "customer_reading.integer": "Leitura do cliente deve ser numérico.",
      "handbag_number.integer": "Número da bolsa deve ser numérico.",
    }
  }

  get sanitizationRules() {
    return {
      client_long: "coordinates",
      client_lat: "coordinates",
      notes: "formatText",
    }
  }
}

module.exports = new RouteItems()
